import styled from "styled-components";
import { DialogActions } from "@mui/material";

export const VerticalActions = styled(DialogActions)`
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
`;